export default "__VITE_ASSET__COt_3R0q__"